import axios from "axios";

const API_BASE_URL =
  import.meta?.env?.VITE_API_URL ||
  process.env.REACT_APP_API_URL ||
  "https://graficosb-production.up.railway.app";

export const bancoCentralService = {
  getSerie: async (serieId, startDate, endDate) => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/banco-central/obtenerSerie`,
        { serieId, startDate, endDate },
        { timeout: 60000 } // ↑ 60s
      );
      return res.data;
    } catch (err) {
      // Reintento 1 si fue timeout
      if (err?.code === "ECONNABORTED") {
        const res2 = await axios.post(
          `${API_BASE_URL}/api/banco-central/obtenerSerie`,
          { serieId, startDate, endDate },
          { timeout: 60000 }
        );
        return res2.data;
      }
      console.error("Error en getSerie:", err?.message || err);
      throw err;
    }
  },
};
